import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import dayjs from "dayjs";

export const dateRanges = [
  {
    label: "Last 2 Days",
    value: () => [dayjs().subtract(2, "days"), dayjs()],
  },
  {
    label: "Last 1 Week",
    value: () => [dayjs().subtract(1, "weeks"), dayjs()],
  },
  {
    label: "Last 1 Month",
    value: () => [dayjs().subtract(1, "months"), dayjs()],
  },
  {
    label: "Last 3 Month",
    value: () => [dayjs().subtract(3, "months"), dayjs()],
  },
];

export const garbageType = [
  { label: "(A) Plastics", value: "A" },
  { label: "(B) Food wastes", value: "B" },
  { label: "(C) Domestic wastes", value: "C" },
  { label: "(D) Cooking oil", value: "D" },
  { label: "(E) Incinerator Ashes", value: "E" },
  { label: "(F) Operational wastes", value: "F" },
  { label: "(G) Animal Carcass", value: "G" },
  { label: "(H) Fishing gear", value: "H" },
  { label: "(I) Electronic waste – SEA DISPOSAL PROHIBITED", value: "I" },
];

export const garbageTypeTwo = [
  {
    label:
      "(J) Cargo Residue (Non Harmful to the Marine Environment ‐ (non‐HME))",
    value: "J",
  },
  {
    label: "(K) Cargo Residue (Harmful to Marine Environment (HME))",
    value: "K",
  },
];

export const methodofDisposal = [
  {
    label: "Incineration",
    value: "Incineration",
  },
  {
    label: "PortFacility",
    value: "PortFacility",
  },
  {
    label: "Dumping At Sea",
    value: "DumpingAtSea",
  },
];

export const cylinders = [
  "CYL Exhaust Temp",
  "Scavenge Box Temp",
  "Jacket Water Temp",
  "Fuel Rack",
  "Piston Cooling Oil Out Temp",
  "Exhaust Temperature",
];

export const chartTypes = [
  { value: "Bar", label: "Bar Chart" },
  { value: "Line", label: "Line Chart" },
  { value: "Pie", label: "Pie Chart" },
  { value: "Scatter", label: "Scatter Chart" },
];

export const cardData = [
  {
    title: "Cargo Ship 1",
    description: "Shipping across the ocean",
    image:
      "https://images.pexels.com/photos/1117210/pexels-photo-1117210.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    title: "Cargo Ship 2",
    description: "Global logistics at sea",
    image:
      "https://images.pexels.com/photos/1095814/pexels-photo-1095814.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    title: "Cargo Ship 3",
    description: "Efficient freight transport",
    image:
      "https://images.pexels.com/photos/2144905/pexels-photo-2144905.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    title: "Cargo Ship 4",
    description: "Maritime trade routes",
    image:
      "https://images.pexels.com/photos/3840441/pexels-photo-3840441.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    title: "Cargo Ship 4",
    description: "Maritime trade routes",
    image:
      "https://images.pexels.com/photos/3840441/pexels-photo-3840441.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    title: "Cargo Ship 4",
    description: "Maritime trade routes",
    image:
      "https://images.pexels.com/photos/3840441/pexels-photo-3840441.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    title: "Cargo Ship 4",
    description: "Maritime trade routes",
    image:
      "https://images.pexels.com/photos/3840441/pexels-photo-3840441.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    title: "Cargo Ship 4",
    description: "Maritime trade routes",
    image:
      "https://images.pexels.com/photos/3840441/pexels-photo-3840441.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
];

export const parameterMappings = {
  "Engine-LogBook": [
    { value: "RPM Counter", label: "RPM Counter" },
    { value: "Average RPM", label: "Average RPM" },
    { value: "Hours on full load", label: "Hours on full load" },
    { value: "Sea water Temp", label: "Sea water Temp" },
    { value: "Ambient Temp", label: "Ambient Temp" },
    { value: "Engine Room Temp", label: "Engine Room Temp" },
    {
      value: "Engine Room Barometric Press",
      label: "Engine Room Barometric Press",
    },
    { value: "Engine Speed", label: "Engine Speed" },
    { value: "Engine Distance", label: "Engine Distance" },
    {
      value: "Main Engine Fuel Flow Meter In",
      label: "Main Engine Fuel Flow Meter In",
    },
    {
      value: "Main engine Fuel Flow Meter Out",
      label: "Main engine Fuel Flow Meter Out",
    },
    {
      value: "Auxiliary Engine Fuel Flow Meter In",
      label: "Auxiliary Engine Fuel Flow Meter In",
    },
    {
      value: "Auxiliary engine Fuel Flow Meter Out",
      label: "Auxiliary engine Fuel Flow Meter Out",
    },
    { value: "Boiler Fuel Flow Meter In", label: "Boiler Fuel Flow Meter In" },
    {
      value: "Boiler Fuel Flow Meter Out",
      label: "Boiler Fuel Flow Meter Out",
    },
    {
      value: "Main engine Fuel Consumption",
      label: "Main engine Fuel Consumption",
    },
    {
      value: "Auxiliary Engine Fuel Consumption",
      label: "Auxiliary Engine Fuel Consumption",
    },
    { value: "Boiler Fuel Consumption", label: "Boiler Fuel Consumption" },
    { value: "Cylinder oil Consumption", label: "Cylinder oil Consumption" },
  ],
  "Deck-LogBook": [
    { value: "Sea Condition", label: "Sea Condition" },
    { value: "Wind Condition", label: "Wind Condition" },
    { value: "Swell", label: "Swell" },
    { value: "Speed, GPS", label: "Speed, GPS" },
    { value: "Distance Covered", label: "Distance Covered" },
    { value: "Distance to go", label: "Distance to go" },
    { value: "Loaded/ Ballast", label: "Loaded/ Ballast" },
  ],
  "Souding LogBook": [
    { value: "Fuel Tank Level", label: "Fuel Tank Level" },
    { value: "Water Tank Level", label: "Water Tank Level" },
    { value: "Oil Tank Level", label: "Oil Tank Level" },
    { value: "Bunker Quantity", label: "Bunker Quantity" },
    { value: "Ballast Water Level", label: "Ballast Water Level" },
  ],
};

export const pressureUnits = [
  "Bar",
  "Pa",
  "kPa",
  "MPa",
  "mbar",
  "psi",
  "atm",
  "Torr",
];
export const temperatureUnits = ["°C", "°F", "K", "°R"];
export const lengthUnits = [
  "mm",
  "cm",
  "m",
  "km",
  "inch",
  "ft",
  "yard",
  "mile",
];
export const weightUnits = ["mg", "g", "kg", "ton", "lb", "oz"];
export const volumeUnits = ["mL", "L", "m³", "ft³", "gal", "qt"];
export const speedUnits = ["m/s", "km/h", "mph", "knot"];
export const energyUnits = ["J", "kJ", "cal", "kcal", "Wh", "kWh"];
export const powerUnits = ["W", "kW", "MW", "HP"];
export const torqueUnits = ["N·m", "ft·lb"];
export const frequencyUnits = ["Hz", "kHz", "MHz", "GHz"];
export const loadUnits = ["%"];
export const currentUnits = ["A", "mA", "kA"];
export const vibrationUnits = ["Hz", "RPM", "m/s²", "g"];

export const PurifierOptions = [
  { label: "Running Hours", value: "runningHours" },
  { label: "Total Running Hours", value: "totalRunningHours" },
  { label: "Feed Pressure", value: "feedPressure" },
  { label: "Feed Temperature", value: "feedTemperature" },
  { label: "Back Pressure", value: "backPressure" },
  { label: "Motor Current", value: "motorCurrent" },
  { label: "Motor Temperature", value: "motorTemperature" },
];

export const BoilerOptions = [
  { label: "Running Hours", value: "runningHours" },
  { label: "Total Running Hours", value: "totalRunningHours" },
  { label: "Boiler Pressure", value: "boilerPressure" },
  { label: "Fuel Pressure", value: "fuelPressure" },
  { label: "FD Fan Current", value: "fdFanCurrent" },
  { label: "Boiler Load", value: "boilerLoad" },
  { label: "Fuel Oil Type", value: "fuelOilType" },
];

export const PumpOptions = [
  { label: "Suction Pressure", value: "suctionPressure" },
  { label: "Discharge Pressure", value: "dischargePressure" },
  { label: "Current", value: "current" },
];

export const AirCompressorOptions = [
  { label: "Running Hours", value: "runningHours" },
  { label: "Total Running Hours", value: "totalRunningHours" },
  { label: "1st Stage Suction Pressure", value: "firstStageSuctionPressure" },
  {
    label: "1st Stage Discharge Pressure",
    value: "firstStageDischargePressure",
  },
  { label: "2nd Stage Suction Pressure", value: "secondStageSuctionPressure" },
  {
    label: "2nd Stage Discharge Pressure",
    value: "secondStageDischargePressure",
  },
  { label: "Lube Oil Pressure", value: "lubeOilPressure" },
  { label: "Cooling Water Pressure", value: "coolingWaterPressure" },
  { label: "Cooling Water Temperature", value: "coolingWaterTemperature" },
  { label: "Motor Current", value: "motorCurrent" },
  { label: "Motor Temperature", value: "motorTemperature" },
];

export const FreshWaterGeneratorOptions = [
  { label: "Running Hours", value: "runningHours" },
  { label: "Total Running Hours", value: "totalRunningHours" },
  { label: "Jacket Water In Temp", value: "jacketWaterInTemp" },
  { label: "Jacket Water Out Temp", value: "jacketWaterOutTemp" },
  { label: "Vaccum", value: "vacuum" },
  { label: "Shell Temperature", value: "shellTemperature" },
  { label: "Salinity", value: "salinity" },
  { label: "Flowmeter", value: "flowmeter" },
  { label: "Quantity Produced", value: "quantityProduced" },
  { label: "Feed Water Pressure", value: "feedWaterPressure" },
];

export const AirConditioningPlantOptions = [
  { label: "Suction Pressure", value: "suctionPressure" },
  { label: "Discharge Pressure", value: "dischargePressure" },
  { label: "Lub Oil Pressure", value: "lubOilPressure" },
  { label: "Cooling Water Pressure", value: "coolingWaterPressure" },
  { label: "Cooling Water In Temperature", value: "coolingWaterInTemperature" },
  {
    label: "Cooling Water Out Temperature",
    value: "coolingWaterOutTemperature",
  },
  { label: "Motor Current", value: "motorCurrent" },
  { label: "Motor Temperature", value: "motorTemperature" },
];

export const RefrigerationPlantOptions = [
  { label: "Suction Pressure", value: "suctionPressure" },
  { label: "Discharge Pressure", value: "dischargePressure" },
  { label: "Lub Oil Pressure", value: "lubOilPressure" },
  { label: "Cooling Water Pressure", value: "coolingWaterPressure" },
  { label: "Cooling Water In Temperature", value: "coolingWaterInTemperature" },
  {
    label: "Cooling Water Out Temperature",
    value: "coolingWaterOutTemperature",
  },
  { label: "Motor Current", value: "motorCurrent" },
  { label: "Motor Temperature", value: "motorTemperature" },
  { label: "Fish Room Temperature", value: "fishRoomTemperature" },
  { label: "Meat Room Temperature", value: "meatRoomTemperature" },
  { label: "Veg Room Temperature", value: "vegRoomTemperature" },
];

export const otherAuxilaryMachineData = [
  {
    label: "Fresh Water Generator",
    parameters: [
      "Running Hours",
      "Total Running Hours",
      "Jacket Water In Temp",
      "Jacket Water Out Temp",
      "Vaccum",
      "Shell Temperature",
      "Salinity",
      "Flowmeter",
      "Qunatity Produced",
      "Feed Water Pressure",
    ],
  },
  {
    label: "Air Conditioning Plant",
    parameters: [
      "Suction Pressure",
      "Discharge Pressure",
      "Lub Oil Pressure",
      "Cooilng Water Pressure",
      "Cooling Water In Temperature",
      "Cooling Water Out Temperature",
      "Motor Current",
      "Motor Temperature",
    ],
  },
  {
    label: "Refrigeration Plant",
    parameters: [
      "Suction Pressure",
      "Discharge Pressure",
      "Lub Oil Pressure",
      "Cooilng Water Pressure",
      "Cooling Water In Temperature",
      "Cooling Water Out Temperature",
      "Motor Current",
      "Motor Temperature",
      "Fish Room Temperature",
      "Meat Room Temperature",
      "Veg Room Temperature",
    ],
  },
];

export const BwtsOptions = [
  "Mechanical Filtration",
  "UV Treatment",
  "Electrochlorination",
  "Chemical Injection",
  "Ozone-Based",
  "Deoxygenation/Cavitation",
];

export const bwtsData = [
  {
    label: "Mechanical Filtration",
    parameters: [
      "Inlet Pressure",
      "Outlet Pressure",
      "Pressure Δ",
      "Backflush Cycle",
      "Flow Rate",
      "Operation (Ballasting/Deballasting)",
      "Operation Hours",
      "Total Operation Hours",
    ],
  },
  {
    label: "UV Treatment",
    parameters: [
      "UV Intensity",
      "UV Transmittance (UVT)",
      "Flow Rate",
      "Lamp Hours",
      "Lamp Status",
      "Ballast Pump Status",
      "Inlet/Outlet Pressure",
      "Temperature",
      "Operation (Ballasting/Deballasting)",
      "Operation Hours",
      "Total Operation Hours",
    ],
  },
  {
    label: "Electrochlorination",
    parameters: [
      "Chlorine Production Rate",
      "Power Consumption",
      "Electrode Voltage/Current",
      "Flow Rate",
      "TRO Level",
      "Neutralizer Dose",
      "Salinity",
      "Holding Time",
      "Operation (Ballasting/Deballasting)",
      "Operation Hours",
      "Total Operation Hours",
    ],
  },
  {
    label: "Chemical Injection",
    parameters: [
      "Chemical Dosage",
      "Injection Rate",
      "TRO Level",
      "Neutralizer Dose",
      "Storage Tank Level",
      "Contact Time",
      "Flow Rate",
      "Temperature",
      "Operation (Ballasting/Deballasting)",
      "Operation Hours",
      "Total Operation Hours",
    ],
  },
  {
    label: "Ozone-Based",
    parameters: [
      "Ozone Dose",
      "ORP",
      "Gas Generator Status",
      "Off-gas Destruction Status",
      "Flow Rate",
      "Holding Time",
      "Residual Ozone",
      "Operation (Ballasting/Deballasting)",
      "Operation Hours",
      "Total Operation Hours",
    ],
  },
  {
    label: "Deoxygenation/Cavitation",
    parameters: [
      "Dissolved Oxygen (DO) Level",
      "Pressure/Vacuum Level",
      "Cavitation Intensity",
      "Flow Rate",
      "Holding Time",
      "Operation (Ballasting/Deballasting)",
      "Operation Hours",
      "Total Operation Hours",
    ],
  },
];

export const machineMap = {
  "FRESH WATER GENERATOR": 1,
  "AIR CONDITIONING PLANT": 2,
  "REFRIGERATION PLANT": 3,
  OTHER: 4,
};

export const IGGOptions = [
  { label: "Fuel Oil Pressure", value: "fuel_oil_pressure" },
  { label: "Fuel Oil Temperature", value: "fuel_oil_temperature" },
  { label: "Combustion Air Pressure", value: "combustion_air_pressure" },
  { label: "Oxygen Content (%) in Inert Gas", value: "oxygen_content" },
  {
    label: "Inert Gas Pressure (Discharge Pressure)",
    value: "inert_gas_pressure",
  },
  {
    label: "Inert Gas Temperature (before deck seal)",
    value: "inert_gas_temp",
  },
  { label: "Inert Gas Flow Rate", value: "inert_gas_flow_rate" },
  { label: "IG Fan RPM / Speed", value: "ig_fan_rpm" },
  { label: "Scrubber Water Inlet Pressure", value: "scrubber_inlet_pressure" },
  { label: "Scrubber Water Outlet Temperature", value: "scrubber_outlet_temp" },
  { label: "Scrubber Water Flow Rate", value: "scrubber_flow_rate" },
  { label: "Scrubber Drain Temperature", value: "scrubber_drain_temp" },
  { label: "Deck Seal Water Level", value: "deck_seal_water_level" },
  {
    label: "Deck Seal Differential Pressure",
    value: "deck_seal_diff_pressure",
  },
  { label: "Operation (Ballasting/Deballasting)", value: "operation" },
  { label: "Operation Hours", value: "operation_hours" },
  { label: "Total Operation Hours", value: "total_operation_hours" },
];
export const CargoCraneOptions = [
  { value: "total_operating_hours", label: "Total Operating Hours" },
  { value: "hydraulic_oil_pressure", label: "Hydraulic Oil Pressure" },
  { value: "hydraulic_oil_temperature", label: "Hydraulic Oil Temperature" },
  { value: "motor_current", label: "Motor Current" },
  { value: "motor_temperature", label: "Motor Temperature" },
  { value: "actual_load_weight", label: "Actual Load Weight" },
  {
    value: "percentage_rated_capacity_used",
    label: "Percentage of Rated Capacity Used",
  },
  { value: "radius_of_load", label: "Radius of Load" },
  { value: "load_moment", label: "Load Moment" },
  { value: "boom_angle", label: "Boom Angle" },
  { value: "boom_length", label: "Boom Length" },
  { value: "slew_angle", label: "Slew Angle" },
  { value: "fly_jib_angle", label: "Fly Jib Angle" },
  { value: "fly_jib_length", label: "Fly Jib Length" },
  { value: "wind_speed", label: "Wind Speed" },
  { value: "vessel_heel", label: "Vessel Heel" },
  { value: "vessel_trim", label: "Vessel Trim" },
  { value: "number_of_lifting_cycles", label: "Number of Lifting Cycles" },
  { value: "idle_time", label: "Idle Time" },
  {
    value: "hoisting_motions",
    label: "Number and Duration of Hoisting Motions",
  },
  { value: "luffing_motions", label: "Number and Duration of Luffing Motions" },
  { value: "slewing_motions", label: "Number and Duration of Slewing Motions" },
  { label: "Operation (Ballasting/Deballasting)", value: "operation" },
  { label: "Operation Hours", value: "operation_hours" },
  { label: "Total Operation Hours", value: "total_operation_hours" },
];
export const LpgCargoCompressorOptions = [
  { label: "Suction Pressure (bar)", value: "Suction Pressure" },
  { label: "Discharge Pressure (bar)", value: "Discharge Pressure" },
  { label: "Interstage Pressure (bar)", value: "Interstage Pressure" },
  { label: "Lube Oil Pressure (bar)", value: "Lube Oil Pressure" },
  { label: "Oil Separator Pressure (bar)", value: "Oil Separator Pressure" },
  { label: "Suction Temperature (°C)", value: "Suction Temperature" },
  { label: "Discharge Temperature (°C)", value: "Discharge Temperature" },
  { label: "Interstage Temperature (°C)", value: "Interstage Temperature" },
  { label: "Superheat Temperature (°C)", value: "Superheat Temperature" },
  { label: "Lube Oil Temperature (°C)", value: "Lube Oil Temperature" },
  {
    label: "Cooling Water Inlet Temperature (°C)",
    value: "Cooling Water Inlet Temperature",
  },
  {
    label: "Cooling Water Outlet Temperature (°C)",
    value: "Cooling Water Outlet Temperature",
  },
  { label: "Sea Water Temperature (°C)", value: "Sea Water Temperature" },
  {
    label: "Motor Bearing Temperature (°C)",
    value: "Motor Bearing Temperature",
  },
  { label: "Refrigerant Flow Rate (kg/h)", value: "Refrigerant Flow Rate" },
  { label: "Vapor Return Flow Rate (kg/h)", value: "Vapor Return Flow Rate" },
  { label: "Cooling Water Flow Rate (m³/h)", value: "Cooling Water Flow Rate" },
  { label: "Motor Voltage (V)", value: "Motor Voltage" },
  { label: "Motor Current (A)", value: "Motor Current" },
  { label: "Power Consumption (kW)", value: "Power Consumption" },
  { label: "Compressor Speed / RPM (RPM)", value: "Compressor Speed / RPM" },
  { label: "Lube Oil Level (%)", value: "Lube Oil Level" },
  { label: "Running Hours Today (hours)", value: "Running Hours Today" },
  { label: "Total Running Hours (hours)", value: "Total Running Hours" },
  { label: "Operation (Ballasting/Deballasting)", value: "operation" },
  { label: "Operation Hours", value: "operation_hours" },
  { label: "Total Operation Hours", value: "total_operation_hours" },
];
export const LngCargoCompressorOptions = [
  { label: "Compressor Number/ID", value: "compressor_number_id" },
  { label: "Compressor Status", value: "compressor_status" },
  { label: "Mode of Operation", value: "mode_of_operation" },
  { label: "Suction Pressure", value: "suction_pressure" },
  { label: "Interstage Pressure", value: "interstage_pressure" },
  { label: "Discharge Pressure", value: "discharge_pressure" },
  { label: "Oil Separator Pressure", value: "oil_separator_pressure" },
  { label: "Suction Temperature", value: "suction_temperature" },
  { label: "Interstage Temperature", value: "interstage_temperature" },
  { label: "Discharge Temperature", value: "discharge_temperature" },
  { label: "Lube Oil Temperature", value: "lube_oil_temperature" },
  {
    label: "Cooling Water Inlet Temperature",
    value: "cooling_water_inlet_temperature",
  },
  {
    label: "Cooling Water Outlet Temperature",
    value: "cooling_water_outlet_temperature",
  },
  { label: "Motor Winding Temperature", value: "motor_winding_temperature" },
  { label: "Ambient Temperature", value: "ambient_temperature" },
  { label: "Gas Flow Rate", value: "gas_flow_rate" },
  { label: "Compressor Speed", value: "compressor_speed" },
  { label: "Lube Oil Pressure", value: "lube_oil_pressure" },
  { label: "Lube Oil Level", value: "lube_oil_level" },
  {
    label: "Oil Filter Differential Pressure",
    value: "oil_filter_differential_pressure",
  },
  { label: "Cooling Water Flow Rate", value: "cooling_water_flow_rate" },
  { label: "Sea Water Temperature", value: "sea_water_temperature" },
  { label: "Motor Voltage", value: "motor_voltage" },
  { label: "Motor Current", value: "motor_current" },
  { label: "Power Consumption", value: "power_consumption" },
  { label: "Motor Running Hours", value: "motor_running_hours" },
  { label: "Overload Trip Status", value: "overload_trip_status" },
  {
    label: "High Discharge Pressure Alarm",
    value: "high_discharge_pressure_alarm",
  },
  { label: "Low Suction Pressure Alarm", value: "low_suction_pressure_alarm" },
  {
    label: "High Discharge Temperature Alarm",
    value: "high_discharge_temperature_alarm",
  },
  { label: "Emergency Stop Activated", value: "emergency_stop_activated" },
  { label: "Vibration Level", value: "vibration_level" },
  { label: "Any Alarms/Trips Noted", value: "any_alarms_trips_noted" },
  { label: "Start/Stop Time", value: "start_stop_time" },
  { label: "Running Hours Today", value: "running_hours_today" },
  { label: "Total Running Hours", value: "total_running_hours" },
  { label: "Remarks / Observations", value: "remarks_observations" },
  { label: "Maintenance Done / Due", value: "maintenance_done_due" },
  { label: "Operation (Ballasting/Deballasting)", value: "operation" },
  { label: "Operation Hours", value: "operation_hours" },
  { label: "Total Operation Hours", value: "total_operation_hours" },
];

export const NitrogenPlantOptions = [
  {
    label: "Plant Status (Running / Standby / Stopped)",
    value: "plant_status",
  },
  { label: "Mode of Operation (Manual / Auto)", value: "mode_of_operation" },
  {
    label: "Compressor Suction Pressure (bar)",
    value: "compressor_suction_pressure",
  },
  {
    label: "Compressor Discharge Pressure (bar)",
    value: "compressor_discharge_pressure",
  },
  {
    label: "Compressor Suction Temperature (°C)",
    value: "compressor_suction_temperature",
  },
  {
    label: "Compressor Discharge Temperature (°C)",
    value: "compressor_discharge_temperature",
  },
  {
    label: "Lubricating Oil Pressure (bar)",
    value: "lubricating_oil_pressure",
  },
  {
    label: "Lubricating Oil Temperature (°C)",
    value: "lubricating_oil_temperature",
  },
  {
    label: "Compressor Running Hours (hours)",
    value: "compressor_running_hours",
  },
  {
    label: "Inlet Air Temperature to Dryer (°C)",
    value: "inlet_air_temp_to_dryer",
  },
  {
    label: "Outlet Air Temperature from Dryer (°C)",
    value: "outlet_air_temp_from_dryer",
  },
  { label: "Dryer Dew Point (°C)", value: "dryer_dew_point" },
  {
    label: "Cooling Water Inlet Temperature (°C)",
    value: "cooling_water_inlet_temp",
  },
  {
    label: "Cooling Water Outlet Temperature (°C)",
    value: "cooling_water_outlet_temp",
  },
  {
    label: "Nitrogen Delivery Pressure (bar)",
    value: "nitrogen_delivery_pressure",
  },
  { label: "Nitrogen Flow Rate (Nm³/h)", value: "nitrogen_flow_rate" },
  { label: "Nitrogen Purity (%)", value: "nitrogen_purity" },
  { label: "Oxygen Content in N₂ (%)", value: "oxygen_content_in_n2" },
  { label: "Product Temperature (°C)", value: "product_temperature" },
  { label: "Heater Inlet Temperature (°C)", value: "heater_inlet_temperature" },
  {
    label: "Heater Outlet Temperature (°C)",
    value: "heater_outlet_temperature",
  },
  { label: "Heater Power Consumption (kW)", value: "heater_power_consumption" },
  { label: "Instrument Air Pressure (bar)", value: "instrument_air_pressure" },
  { label: "Instrument Air Dew Point (°C)", value: "instrument_air_dew_point" },
  { label: "Power Supply Voltage (V)", value: "power_supply_voltage" },
  { label: "Running Current (A)", value: "running_current" },
  { label: "Power Consumption (kW)", value: "power_consumption" },
  { label: "Start / Stop Time", value: "start_stop_time" },
  { label: "Total Running Hours (hours)", value: "total_running_hours" },
  {
    label: "Operation (Ballasting / Deballasting)",
    value: "operation_ballasting_deballasting",
  },
  { label: "Operation Hours", value: "operation_hours" },
  { label: "Total Operation Hours", value: "total_operation_hours" },
];

export const coptData = [
  {
    label: "Turbine Parameters",
    parameters: [
      "Turbine Speed (RPM)",
      "Steam Inlet Pressure (MPa)",
      "Steam Inlet Temperature (°C)",
      "Steam Exhaust Pressure (MPa)",
      "Bearing Temp 1 (Turbine) (°C)",
      "Bearing Temp 2 (Turbine) (°C)",
      "Vibration - Horizontal (Turbine) (mm/s RMS)",
      "Vibration - Vertical (Turbine) (mm/s RMS)",
      "Vibration - Axial (Turbine) (mm/s RMS)",
      "Lube Oil Pressure (MPa)",
      "Lube Oil Temperature (°C)",
      "Condensate Discharge Pressure (MPa)",
      "Operation (Ballasting / Deballasting)",
      "Operation Hours",
      "Total Operation Hours",
    ],
  },
  {
    label: "Pump Parameters",
    parameters: [
      "Pump Discharge Pressure (MPa)",
      "Pump Suction Pressure (MPa)",
      "Flow Rate (m³/hr)",
      "Pump Speed (RPM)",
      "Bearing Temp 1 (Pump) (°C)",
      "Bearing Temp 2 (Pump) (°C)",
      "Vibration - Horizontal (Pump) (mm/s RMS)",
      "Vibration - Vertical (Pump) (mm/s RMS)",
      "Vibration - Axial (Pump) (mm/s RMS)",
      "Stuffing Box Leakage (Qualitative)",
      "Operation (Ballasting / Deballasting)",
      "Operation Hours",
      "Total Operation Hours",
    ],
  },
  {
    label: "System Parameters",
    parameters: [
      "Crude Oil Temp at Inlet (°C)",
      "Washing Guns Active (Number)",
      "Washing Cycle Stage",
      "Washing Duration (Minutes)",
      "Tank Being Washed",
      "Operation (Ballasting / Deballasting)",
      "Operation Hours",
      "Total Operation Hours",
    ],
  },
  {
    label: "Environmental Parameters (Optional)",
    parameters: [
      "Ambient Temperature (°C)",
      "Humidity (%RH)",
      "Operation (Ballasting / Deballasting)",
      "Operation Hours",
      "Total Operation Hours",
    ],
  },
];

export const framoData = [
  {
    label: "Framo Pump Parameters",
    parameters: [
      "Hydraulic oil pressure (supply)",
      "Hydraulic oil pressure (return)",
      "Hydraulic oil temperature",
      "Hydraulic oil level",
      "Pump speed (RPM)",
      "Discharge pressure",
      "Suction pressure / vacuum",
      "Flow rate",
      "Vibration level",
      "Electric motor current (power pack)",
      "Electric power consumption",
      "Running hours",
    ],
  },
];

export const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo (Congo-Brazzaville)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czechia (Czech Republic)",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar (Burma)",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const stayData = [
  { value: "SS", label: "SEA PASSAGE" },
  { value: "HM", label: "HARBOUR MANOEUVRING" },
  { value: "PORT", label: "PORT" },
  { value: "DRIFT", label: "DRIFT" },
  { value: "ANCH", label: "ANCHOR" },
];

export const typeOfEventOptions = [
  { value: "SBE", label: "SBE" },
  { value: "COSP", label: "COSP" },
  { value: "NOON", label: "NOON" },
  { value: "EOSP", label: "EOSP" },
  { value: "FWE", label: "FWE" },
];

export const voyageOptions = [
  { value: "HSFO", label: "HSFO" },
  { value: "VLSFO", label: "VLSFO" },
  { value: "LSMGO", label: "LSMGO" },
  { value: "MECC", label: "MECC" },
  { value: "AECC", label: "AECC" },
  { value: "HTBN", label: "HTBN" },
  { value: "LTBN", label: "LTBN" },
  { value: "FW", label: "FW" },
];

export const fuelTypeOptions = [
  { value: "HSFO", label: "HSFO" },
  { value: "VLSFO", label: "VLSFO" },
  { value: "DIESEL_GAS_OIL", label: "DIESEL/GAS OIL" },
  { value: "LPG", label: "LPG (PROPANE)" },
  { value: "LPGB", label: "LPG (BUTANE)" },
  { value: "LNG", label: "LNG" },
  { value: "METHANOL", label: "METHANOL" },
  { value: "ETHANOL", label: "ETHANOL" },
];

export const lubOilTypeOptions = [
  { value: "HTBN", label: "HTBN" },
  { value: "LTBN", label: "LTBN" },
  { value: "MECC", label: "MECC" },
  { value: "AECC", label: "AECC" },
];

export const bunkerGradeOptions = [
  { value: "HSFO", label: "HSFO" },
  { value: "VLSFO", label: "VLSFO" },
  { value: "DIESEL_GAS_OIL", label: "DIESEL/GAS OIL" },
  { value: "LPG", label: "LPG (PROPANE)" },
  { value: "LPGB", label: "LPG (BUTANE)" },
  { value: "LNG", label: "LNG" },
  { value: "METHANOL", label: "METHANOL" },
  { value: "ETHANOL", label: "ETHANOL" },
  { value: "HTBN", label: "HTBN" },
  { value: "LTBN", label: "LTBN" },
  { value: "MECC", label: "MECC" },
  { value: "AECC", label: "AECC" },
  { value: "FW", label: "FW" },
];

export const robOptions = [
  { value: "HSFO", label: "HSFO" },
  { value: "VLSFO", label: "VLSFO" },
  { value: "DIESEL_GAS_OIL", label: "DIESEL/GAS OIL" },
  { value: "LPG", label: "LPG (PROPANE)" },
  { value: "LPGB", label: "LPG (BUTANE)" },
  { value: "LNG", label: "LNG" },
  { value: "METHANOL", label: "METHANOL" },
  { value: "ETHANOL", label: "ETHANOL" },
  { value: "HTBN", label: "HTBN" },
  { value: "LTBN", label: "LTBN" },
  { value: "MECC", label: "MECC" },
  { value: "AECC", label: "AECC" },
  { value: "FW", label: "FW" },
];

const isDateString = (value) => {
  if (typeof value !== "string") return false;

  const trimmed = value.trim();
  if (/^\d+$/.test(trimmed)) return false;

  const date = new Date(trimmed);
  return !isNaN(date.getTime());
};

const formatDateTime = (value) => {
  const date = new Date(value);
  if (isNaN(date.getTime())) return value;

  const options = value.includes(":")
    ? {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }
    : {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };

  return date.toLocaleString(undefined, options);
};

const renderValue = (text) => {
  const iconStyle = { fontSize: 18 };

  if (typeof text === "string") {
    const val = text.trim().toLowerCase();

    if (val === "true") {
      return <CheckCircleTwoTone twoToneColor="#52c41a" style={iconStyle} />;
    }

    if (val === "false") {
      return <CloseCircleTwoTone twoToneColor="#ff4d4f" style={iconStyle} />;
    }

    if (val === "none" || val === "") {
      return "N/A";
    }

    if (isDateString(text)) {
      return formatDateTime(text);
    }

    try {
      const parsed = JSON.parse(text);
      return renderParsedObject(parsed);
    } catch {
      // Not a JSON string
    }
  }

  if (typeof text === "object" && text !== null) {
    return renderParsedObject(text);
  }

  if (text === null || text === undefined) {
    return "N/A";
  }

  return text;
};

const renderParsedObject = (data) => {
  if (Array.isArray(data)) {
    return data.map((item, index) => (
      <div key={index}>{renderParsedObject(item)}</div>
    ));
  }

  if (typeof data === "object" && data !== null) {
    return Object.entries(data)
      .map(([key, value]) => `${key}: ${value}`)
      .join(", ");
  }

  return String(data);
};

export const columns2 = [
  {
    title: "Field Name",
    dataIndex: "field",
    key: "field",
    align: "center",
  },
  {
    title: "Old Value",
    dataIndex: "oldValue",
    key: "oldValue",
    align: "center",
    render: renderValue,
  },
  {
    title: "Updated Value",
    dataIndex: "newValue",
    key: "newValue",
    align: "center",
    render: renderValue,
  },
];

export const chartOptions = [
  // { value: "pie", label: "Pie Chart" },
  { value: "line", label: "Line Chart" },
  { value: "bar", label: "Bar Chart" },
  { value: "scatter", label: "Scatter Chart" },
];

export const chartFields = [
  { value: "Bilge Water Generation", label: "Bilge Water Generation" },
  { value: "Sludge Generation", label: "Sludge Generation" },
  { value: "Evaporation", label: "Evaporation" },
  { value: "15 ppm Overboard", label: "15 ppm Overboard" },
];

/**. audit trail view module data  */
